import ENDPOINTS from '../../const/endpoints';
export const accountCreditLimitChangeCacheKey = ({ accountId, accountIdType }) => [ENDPOINTS.creditLimitChange, { accountId, accountIdType }];
